import { UUID_PATTERN } from '@/utils'
import { getCloneQParams } from './utils' // router utils

/* Loader */
import AssayNewView from '@/views/new/AssayNewView.vue'
import AssayInitializeView from '@/views/data-loader/AssayInitializeView.vue'
import AssayVerifyView from '@/views/data-loader/AssayVerifyView.vue'

import WizardView from '@/views/data-loader/WizardView.vue'

import SelectAssayTypeView from '@/views/data-loader/SelectAssayTypeView.vue'
import SelectDataView from '@/views/data-loader/SelectDataView.vue'
import AssayDetailsView from '@/views/data-loader/AssayNewView.vue'
import DatasetBuilderView from '@/views/data-loader/DatasetBuilderView.vue'
import GenericVerifyView from '@/views/data-loader/GenericVerifyView.vue'
import AssayAssignSamplesView from '@/views/data-loader/AssayAssignSamplesView.vue'
import GenericAssignSamplesView from '@/views/data-loader/GenericAssignSamplesView.vue'

import ImportSuccessView from '@/views/data-loader/ImportSuccessView.vue'

const dataloaderRoutes = [
  {
    path: '/assays/assays/:modelType?/new',
    component: AssayNewView,
    name: 'assayNew',
    props: (route) => ({
      ...route.params,
      appName: 'assays',
      modelName: 'assays',
      ...getCloneQParams(route.query),
    }),
  },
  {
    // LEGACY URL
    path: `/assays/assays/ngsilluminaassay/:id(${UUID_PATTERN})/initialize`,
    component: AssayInitializeView,
    name: 'assayInitialize',
    props: true,
  },
  {
    path: '/register',
    component: WizardView,
    props: {
      managed: true,
    },
    children: [
      {
        name: 'assayVerify',
        path: 'verify',
        component: AssayVerifyView,
        meta: {
          id: 'verify',
          label: 'Verify',
          iconClasses: 'fa fa-eye',
        },
      },
      {
        name: 'assayAssignSamples',
        path: 'assign-samples',
        component: AssayAssignSamplesView,
        props: (route) => ({
          ...route.params,
        }),
        meta: {
          id: 'assign-samples',
          label: 'Assign samples',
          iconClasses: 'fa fa-vial',
        },
      },
    ],
  },
  {
    // RAW DATA LOADER
    path: '/import-data',
    name: 'importDatasets',
    component: WizardView,
    children: [
      {
        path: 'select-assay-type',
        name: 'assayTypeSelect',
        component: SelectAssayTypeView,
        meta: {
          id: 'select-assay-type',
          label: 'Start',
          iconClasses: 'fa fa-thermometer-empty',
        },
      },
      {
        path: 'select-data',
        name: 'rawDatabox',
        component: SelectDataView,
        meta: {
          id: 'select-data',
          label: 'Select Data',
          iconClasses: 'fa fa-folder-open',
        },
      },
      {
        path: 'assay-details',
        name: 'assayDetails',
        component: AssayDetailsView,
        meta: {
          id: 'assay-details',
          label: 'Assay details',
          iconClasses: 'fa fa-thermometer-three-quarters',
        },
      },
      {
        path: 'build-datasets',
        name: 'rawDatasetBuilder',
        component: DatasetBuilderView,
        meta: {
          id: 'build',
          label: 'Build datasets',
          iconClasses: 'fa fa-layer-group',
        },
      },
      {
        path: 'verify',
        name: 'rawGenericVerify',
        component: GenericVerifyView,
        meta: {
          id: 'verify',
          label: 'Verify',
          iconClasses: 'fa fa-eye',
        },
      },
      {
        path: 'assign-samples',
        name: 'rawAssignSamples',
        component: GenericAssignSamplesView,
        meta: {
          id: 'assign-samples',
          label: 'Assign samples',
          iconClasses: 'fa fa-vial',
        },
      },
    ],
  },
  {
    path: '/load/success',
    component: ImportSuccessView,
    name: 'importSuccess',
    meta: {
      id: 'registration-success',
    },
  },
]

export default dataloaderRoutes
